import { Component } from "@angular/core";
import { IonicPage, NavController, NavParams, AlertController, Events } from "ionic-angular";
import { AuthProvider } from "../../providers/auth/auth.provider";
import { CguPage } from "../cgu/cgu";
import { UserProvider } from "../../providers/user/user.provider";
import { TabsPage } from "../tabs/tabs";

/**
 * Generated class for the AccountOptionsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: "page-account-options",
  templateUrl: "account-options.html"
})
export class AccountOptionsPage {
  user:any;

  constructor(
    public navCtrl: NavController, 
    public navParams: NavParams,
    public events: Events,
    public alertCtrl: AlertController,
    public authProvider: AuthProvider,
    public userProvider: UserProvider
  ) {}

  ionViewDidLoad() {
    console.log("ionViewDidLoad AccountOptionsPage");
    this.refresh();
  }

  async refresh(){
    this.user = await this.userProvider.getUser();
  }

  updateEmail(){
    this.showPrompt("Adresse email","Saisir la nouvelle adresse email","email");
  }

  updatePassword(){
    this.showPrompt("Mot de passe","Saisir le nouveau mot de passe","password");
  }

  deleteAccount(){
    this.presentAlert('Supression du compte','Êtes-vous certain de vouloir supprimer votre compte ?','delete');
  }

  presentAlert(title,message,action){
    let buttons = [
      {
        text: 'Annuler',
        handler: () => {
          console.log('Agree clicked');
        }
      },

      {
        text: 'Confirmer',
        handler: () => {
          console.log('Agree clicked');
            this.updateAccount();
        }
      }
    ]
    if(action == 'logout'){
      buttons = [
        {
          text: 'Continuer',
          handler: () => {
            console.log('Agree clicked');
            this.authProvider.doLogout().then(_ => {
              this.userProvider.setUser(null);
              this.navCtrl.setRoot(TabsPage);
            });
          }
        }
      ];
    }
    const confirm = this.alertCtrl.create({
      title: title,
      message: message,
      buttons: buttons
    });
    confirm.present();
  }
  
  showPrompt(title,text,type) {
    let placeholder = '';
    if(type ==  'email'){
      placeholder = "Nouvelle adresse email";
    }
    if(type ==  'password'){
      placeholder = "Nouveau mot de passe";
    }
    const prompt = this.alertCtrl.create({
      title: title,
      message: text,
      inputs: [
        {
          name: 'value',
          placeholder: placeholder
        },
      ],
      buttons: [
        {
          text: 'Annuler',
          handler: data => {
            console.log('Cancel clicked');
          }
        },
        {
          text: 'Confirmer',
          handler: data => {
            console.log('Saved clicked');
            if(type ==  'email'){
              this.changeEmail(data);
            }
            if(type ==  'password'){
              this.changePassword(data);
            }
          }
        }
      ]
    });
    prompt.present();
  }

  async changePassword(data) {
    console.log("changePassword",data);
    await this.authProvider.changePassword(data.value);
  }
  async changeEmail(data) {
    console.log("changeEmail",data);
    await this.authProvider.changeEmail(data.value);
  }

  async updateAccount(){
    await this.userProvider.disableUser(this.user);
    this.presentAlert('Compte supprimé','Votre compte à bien été supprimé, vous êtes désormais déconnecté.','logout');
  
  }

  goToCGU(){
    this.navCtrl.push(CguPage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/account-options/account-options.ts